import React, { useCallback, useState } from 'react'
import { rem } from 'polished'
import SolidTrianglePointerIcon from 'LuxKit/Icons/solid/SolidTrianglePointerIcon'
import SocieteCampaignUnlockTierCard from './SocieteCampaignUnlockTierCard'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'
import useSocieteNotificationFetcher from 'businessTraveller/hooks/useSocieteNotificationFetcher'
import { useAppDispatch } from 'hooks/reduxHooks'
import updateEmployeeNotification from 'actions/businessTraveller/updateEmployeeNotification'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

function UnlockTierDropdown() {
  const isSocieteEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.lebtSociete)
  const [isDismissed, setIsDismissed] = useState(false)
  const { targetTier } = useSocieteCampaignTargetTier()
  const shouldShow = useSocieteNotificationFetcher()
  const dispatch = useAppDispatch()

  const dismiss = useCallback(() => {
    setIsDismissed(true)
    dispatch(updateEmployeeNotification({ societe: { unlockTierDismissed: true } }))
  }, [dispatch])

  if (!isSocieteEnabled || !shouldShow || isDismissed) return null

  return <div style={{ position: 'absolute', top: 'calc(100% + 9px)', right: '0', width: rem(375) }}>
    <SolidTrianglePointerIcon size="L" colour={`tier-${targetTier}`} style={{ position: 'absolute', top: `-${rem(18)}`, right: rem(32), zIndex: 1 }} />
    <SocieteCampaignUnlockTierCard onDismiss={dismiss} />
  </div>
}

export default UnlockTierDropdown
